//
// Instructions
//

// A nav has been provided with this solution. Feel free to change class names
// to better suit your requirements.

const mobileBtn = document.querySelector('#mobileBtn');
const nav = document.querySelector('#nav');
const navBtns = document.querySelectorAll('.navBtn');
const siteHeader = document.querySelector('.siteHeader');
const siteLogo =document.querySelector('.site-logo');
const body = document.querySelector('body');

if (mobileBtn) {

    mobileBtn.addEventListener('click', () => {
        mobileBtn.classList.toggle('active');
        nav.classList.toggle('active');
        siteHeader.classList.toggle('active');
        siteLogo.classList.toggle('active');
        body.classList.toggle('no-scroll');
    });

    for (let i = 0; i < navBtns.length; i++) {
        navBtns[i].addEventListener('click', () => {
            navBtns[i].classList.toggle('active');
            navBtns[i].parentElement.classList.toggle('active');
        })
    }
}
